// import React, { useState } from 'react';
// import FadeInSection from './FadeInSection'; // Import the general animation wrapper
// import './CallToActionForm.css';

// function CallToActionForm() {
//   const [formData, setFormData] = useState({
//     email: '',
//     company: '',
//     aiStage: 'Exploring AI Opportunities',
//     message: '',
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const newErrors = {};
//     if (!formData.email.includes('@')) newErrors.email = 'Please enter a valid email address.';
//     if (!formData.company) newErrors.company = 'Company name is required.';

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//     } else {
//       try {
//         const response = await fetch('/submit_inquiry', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(formData),
//         });

//         if (!response.ok) {
//           throw new Error('Failed to submit the form');
//         }

//         alert('Thank you! Your inquiry has been submitted successfully.');
//         setFormData({
//           email: '',
//           company: '',
//           aiStage: 'Exploring AI Opportunities',
//           message: '',
//         });
//         setErrors({});
//       } catch (error) {
//         console.error('Error submitting the form:', error);
//         alert('An error occurred while submitting your form. Please try again later.');
//       }
//     }
//   };


//   return (
//     <FadeInSection className="cta-container" id="form">
//       <div className="cta-content">
//         {/* Left Column */}
//         <div className="cta-left">
//           <h2>Get Started Today</h2>
//           <p className="cta-paragraph">
//             Want to integrate AI Agents into your business with minimal friction?
//           </p>
//           <p className="cta-paragraph">
//             Contact us today to learn how Modlee can help you deploy AI solutions that work from day one.
//           </p>
//         </div>

//         {/* Right Column */}
//         <form className="cta-form" onSubmit={handleSubmit}>
//           <label>
//             Work Email*
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="Work Email"
//             />
//             {errors.email && <span className="error">{errors.email}</span>}
//           </label>

//           <label>
//             Company*
//             <input
//               type="text"
//               name="company"
//               value={formData.company}
//               onChange={handleChange}
//               placeholder="Company"
//             />
//             {errors.company && <span className="error">{errors.company}</span>}
//           </label>

//           <label>
//             Current AI Implementation Stage*
//             <select
//               name="aiStage"
//               value={formData.aiStage}
//               onChange={handleChange}
//             >
//               <option>Exploring AI Opportunities</option>
//               <option>Starting AI Projects</option>
//               <option>Scaling AI Operations</option>
//               <option>Mature AI Practice</option>
//             </select>
//           </label>

//           <label>
//             Message
//             <textarea
//               name="message"
//               value={formData.message}
//               onChange={handleChange}
//               placeholder="Let us know how we can help!"
//             ></textarea>
//           </label>

//           <button type="submit">Submit Solution Inquiry</button>
//         </form>
//       </div>
//     </FadeInSection>
//   );
// }

// export default CallToActionForm;


import React, { useState } from "react";
import FadeInSection from "./FadeInSection"; // Animation wrapper
import "./CallToActionForm.css"; // Import new styles

const CallToActionForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    company: "",
    aiStage: "Exploring AI Opportunities",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.email.includes("@")) newErrors.email = "Enter a valid email.";
    if (!formData.company) newErrors.company = "Company name is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      try {
        const response = await fetch("https://agentsserver.modlee.ai:5000/submit_inquiry", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) throw new Error("Failed to submit the form");

        alert("Thank you! Your inquiry has been submitted.");
        setFormData({
          email: "",
          company: "",
          aiStage: "Exploring AI Opportunities",
          message: "",
        });
        setErrors({});
      } catch (error) {
        console.error("Error:", error);
        alert("An error occurred. Please try again later.");
      }
    }
  };

  return (
    <FadeInSection className="cta-container">
      <div className="cta-grid" id="get-started">

        {/* Left Column */}
        <div className="cta-left">
          <h2 className="cta-title">Start Amplifying Your Effort Today</h2>

          <p className="cta-text">Ready to unlock your business’s full potential with AI agents? Our cutting-edge AI infrastructure accelerates your growth, automates tasks, and scales effortlessly.</p>
          <p className="cta-text">Share your AI goals with us, and let’s work together to transform your business and drive lasting success.</p>

        </div>

        {/* Right Column - Form */}
        <form className="cta-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Work Email*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your email"
              className={errors.email ? "input-error" : ""}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label>Company*</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Company name"
              className={errors.company ? "input-error" : ""}
            />
            {errors.company && <span className="error">{errors.company}</span>}
          </div>

          <div className="form-group">
            <label>Current AI Stage*</label>
            <select name="aiStage" value={formData.aiStage} onChange={handleChange}>
              <option>Exploring AI Opportunities</option>
              <option>Starting AI Projects</option>
              <option>Scaling AI Operations</option>
              <option>Mature AI Practice</option>
            </select>
          </div>

          <div className="form-group">
            <label>Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Tell us how we can help"
            ></textarea>
          </div>

          <button type="submit" className="cta-button">Submit</button>
        </form>
      </div>
    </FadeInSection>
  );
};

export default CallToActionForm;
